// extracted by mini-css-extract-plugin
export var activeCard = "testimonials-module--active-card--a0c7d";
export var card = "testimonials-module--card--39396";
export var cards = "testimonials-module--cards--26bc3";
export var person = "testimonials-module--person--f840b";
export var spin = "testimonials-module--spin--054d9";
export var testimonials = "testimonials-module--testimonials--f0f81";
export var title = "testimonials-module--title--d13e0";